/** The single set of Rovodal store keys (one per openable entry). Add new keys here. */
export const RovodalStoreKeys = {
	jiraAdminAgentCanvas: 'jira-admin-agent-canvas',
} as const;

export type RovodalStoreKeys = (typeof RovodalStoreKeys)[keyof typeof RovodalStoreKeys];
